import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Login from "./activity/Login";
import ForgotPassword from "./activity/forgotPassword";
import MainActivity from "./activity/MainActivity";
import { GlobalContext } from "./context/Provider";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import logoutSuccess from "./context/actions/auth/logoutSuccess";
import { GlobalLoading } from "./components/BootstrapCompo";
import henceforthApi from "./utils/henceforthApi";
import VerifyEmail from "./activity/VerifyEmail";
import ResetPassword from "./activity/ResetPassword";
import ContentProvider from "./layout/contentProvider";

export default () => {
  let navigate = useNavigate();
  let location = useLocation();

  const { authState, loading } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);

  return (
    <>
      {authState.access_token ? (
        <Routes>
          <Route path="/" element={<MainActivity />}>
            <Route path="/" />
            <Route path="/race" />
            <Route path="/reported-race" />
            <Route path="race/add" />
            <Route path="race/:id/edit" />
            <Route path="/race/:id/view" />
            <Route path="/policies" />
            <Route path="/policies/add" />
            <Route path="/policies/:id/:type" />
            <Route path="/policies/:id/:type/edit" />
            <Route path="/contact-us/:page" />
            <Route path="/reports/nft/:page" />
            <Route path="/reports/users/:page" />
            <Route path="/notification" />
            <Route path="/profile" />
            <Route path="/profile/edit" />
            <Route path="/staffs/:page/:role" />
            <Route path="/staff/:id" />
            <Route path="/staff/edit/:id" />
            <Route path="/staff/add" />
            <Route path="/email-template" />
            <Route path="/add-template" />
            <Route path="/edit-template" />
            <Route path="/change-password" />
            <Route path="/users/:page" />
            <Route path="/reels/:page" />
            <Route path="/reported-posts/:page" />
            <Route path="/reported-chat/:id/view" />
            <Route path="/reported-chat/:page" />
            <Route path="/reported-reels/:page" />
            <Route path="/reported-stories/:page" />
            <Route path="/user-Messages/:page" />
            <Route path="/user-Message-Details/:id" />
            <Route path="/termServicesPrivacyPolicy/:page" />
            <Route path="/Logout/:page" />
            <Route path="/user/:id/:type/:page" />
            <Route path="/stories/:page" />
            <Route path="/stories/:id" />
            <Route path="/language" />
            <Route path="/faq/:page" />
            <Route path="/faq/edit/:id" />
            <Route path="/faq/add" />
            <Route path="/language/edit/:id" />
            <Route path="/db-backup" />
            <Route path="/posts/:page" />
            <Route path="/posts/:id" />
            <Route path="/posts/:id/photos/public/:page" />
            <Route path="/posts/:id/photos/private/:page" />
            <Route path="/Details_of_User/:page" />
            <Route path="/verify-email" />
            <Route path="/suscriber/:page" />
            <Route path="/transaction/:page"/>
            <Route path="/notification"/>
            <Route path="/media/:id/:type"/>
          </Route>
        </Routes>
      ) : (
        <Routes>
          <Route
            path="/forgot-password"
            element={<ForgotPassword navigate={navigate} location={location} />}
          />
          <Route
            path="/verify-email"
            element={<VerifyEmail navigate={navigate} location={location} />}
          />
          <Route
            path="/reset-password"
            element={<ResetPassword navigate={navigate} location={location} />}
          />
          <Route
            path="/about-us"
            element={<ContentProvider navigate={navigate} location={location} type="ABOUT_US" />}
          />
          <Route
            path="/privacy-policy"
            element={<ContentProvider navigate={navigate} location={location} type="PRIVACY_POLICY" />}
          />
          <Route
            path="/term-and-conditions"
            element={<ContentProvider navigate={navigate} location={location} type="TERM_AND_CONDITION" />}
          />

          <Route
            path="*"
            element={<Login navigate={navigate} location={location} />}
          />
        </Routes>
      )}
      {loading ? <GlobalLoading /> : ""}
      <ToastContainer autoClose={2000} />
    </>
  );
};
